import React from 'react';
import CustomToggle from 'components/CustomToggle/CustomToggle';
import { translate } from 'components/Translation';

interface ISaveCardToggleProps {
	toggle: () => void;
	checked: boolean;
}

const SaveCardToggle = (props: ISaveCardToggleProps) => {
	return (
		<CustomToggle
			label={translate('payments.saveCard')}
			formControlProps={{}}
			checked={!!props.checked}
			value=""
			onChange={() => props.toggle()}
		/>
	);
};

export default SaveCardToggle;
